var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashDepositDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0004 6.24219C32.4824 6.24219 38.5477 12.3075 38.5477 19.7895C38.5477 27.2715 32.4824 33.3368 25.0004 33.3368C17.5185 33.3368 11.4531 27.2715 11.4531 19.7895C11.4531 12.3075 17.5185 6.24219 25.0004 6.24219",
    stroke: "#0074B2",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0006 14.6288V12.9085",
    stroke: "#0074B2",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0006 24.9506V26.6709",
    stroke: "#0074B2",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0171 23.7223C22.4592 24.4768 23.2655 24.9434 24.14 24.9506H26.0323C27.2714 24.9815 28.3317 24.067 28.4829 22.8367C28.6341 21.6065 27.8269 20.4624 26.6172 20.1923L23.3934 19.3821C22.1978 19.102 21.4044 17.9672 21.5518 16.7482C21.6991 15.5291 22.7401 14.6161 23.9679 14.6289H25.8603C26.7356 14.6348 27.5429 15.1016 27.9848 15.8572",
    stroke: "#0074B2",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashDepositDollar);
export default __webpack_public_path__ + "static/media/cash-deposit-dollar.af35c403dfd11992dcd9e87763ddc4ad.svg";
export { ForwardRef as ReactComponent };